// Tools Aggregator
// Exports all tool definitions and executor

import * as listFiles from './listFiles';
import * as readFile from './readFile';
import * as writeFile from './writeFile';
import * as editFile from './editFile';
import * as createFile from './createFile';
import * as inspectDOM from './inspectDOM';
import * as inspectStyles from './inspectStyles';

// All tools registry
const tools = {
  list_files: listFiles,
  read_file: readFile,
  write_file: writeFile,
  edit_file: editFile,
  create_file: createFile,
  inspect_dom: inspectDOM,
  inspect_styles: inspectStyles
};

// Execute tool by name
export async function executeTool(name, args, context) {
  const tool = tools[name];

  if (!tool) {
    return {
      success: false,
      error: `Unknown tool: ${name}`,
      availableTools: Object.keys(tools)
    };
  }

  return await tool.execute(args, context);
}

// Get display message for tool call
export function getToolDisplayMessage(name, args) {
  const tool = tools[name];

  if (!tool) {
    return `Calling ${name}...`;
  }

  if (typeof tool.getDisplayName === 'function') {
    return tool.getDisplayName(args);
  }

  return tool.displayName || `Calling ${name}...`;
}

// Export individual tools for direct access
export { tools };
